import { render, staticRenderFns } from "./ArticleAbstract.vue?vue&type=template&id=5f74f39c&"
import script from "./ArticleAbstract.vue?vue&type=script&lang=ts&"
export * from "./ArticleAbstract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports